import { ChevronLeftIcon } from '@medly-components/icons';
import { type HTMLProps } from 'react';
import { SliderActionButton } from './SliderActions.styled';

export const Previous = ({ className, onClick, disabled }: HTMLProps<HTMLButtonElement>) => (
    <SliderActionButton onClick={onClick} disabled={disabled || className?.includes('slick-disabled')}>
        <ChevronLeftIcon />
    </SliderActionButton>
);
